import React from 'react'

export function Footer() {
  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    window.history.pushState({}, '', href)
    window.dispatchEvent(new Event('popstate'))
    window.scrollTo(0, 0)
  }

  return (
    <footer className="bg-dark-section text-white pt-10 md:pt-20 font-text">
      <div className="text-center py-8 border-t border-gray-800">
        <h2 className="text-4xl md:text-5xl text-white font-bold mb-8 md:mb-12 uppercase tracking-wide font-primary">
          WE DO <span className="underline text-beaver-red decoration-2">DAM</span> GOOD WORK
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 mb-10 px-4">
          <a href="https://www.facebook.com/BusyBeaverConstruction/" className="hover:opacity-80 transition-opacity" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/2020/03/facebook.png" alt="Facebook" className="w-12 h-12 md:w-20 md:h-20" />
          </a>
          <a href="https://www.instagram.com/busybeaverconstruction/" className="hover:opacity-80 transition-opacity" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/2020/03/instagram.png" alt="Instagram" className="w-12 h-12 md:w-20 md:h-20" />
          </a>
          <a href="https://www.google.ca/search?q=Busy+Beaver+Construction+Ltd." className="hover:opacity-80 transition-opacity" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/2020/03/google.png" alt="Google Reviews" className="w-12 h-12 md:w-20 md:h-20" />
          </a>
          <a href="https://www.bbb.org/ca/ab/calgary/profile/deck-builder/busy-beaver-construction-ltd-0017-38381" className="hover:opacity-80 transition-opacity" target="_blank" rel="noopener noreferrer">
            <img src="/assets/images/2020/03/bbb.png" alt="A+ BBB Rated" className="w-24 h-12 md:w-36 md:h-20 object-contain" />
          </a>
        </div>
      </div>
      
      <div className="w-full bg-black">
        <div className="container py-12 md:py-16 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            
            <div className="space-y-4">
              <h3 className="text-xl font-bold text-white font-secondary">Busy Beaver Construction</h3>
              <p className="text-sm text-gray-400 leading-relaxed">
                Calgary's longest-running custom deck and fence builder. Serving homeowners with quality craftsmanship and professional outdoor living solutions since 1999.
              </p>
              <p className="text-xs font-bold text-beaver-green uppercase tracking-widest">
                TimberTech Platinum Pro Builder
              </p>
            </div>

           <div>
  <h3 className="text-lg font-bold text-white mb-4 font-secondary uppercase">
    Our Services
  </h3>

  <ul className="space-y-2 text-sm">

    <li>
      <a
        href="/"
        onClick={(e) => handleNavigation(e, '/')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Custom Decks
      </a>
    </li>

    <li>
      <a
        href="/services/fences"
        onClick={(e) => handleNavigation(e, '/services/fences')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Fence Installation
      </a>
    </li>

    <li>
      <a
        href="/services/pergolas-and-privacy-walls"
        onClick={(e) => handleNavigation(e, '/services/pergolas-and-privacy-walls')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Pergolas & Privacy Walls
      </a>
    </li>

    <li>
      <a
        href="/services/gazebo"
        onClick={(e) => handleNavigation(e, '/services/gazebo')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Custom Gazebos
      </a>
    </li>

    <li>
      <a
        href="/services/living-spaces"
        onClick={(e) => handleNavigation(e, '/services/living-spaces')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Outdoor Living Spaces
      </a>
    </li>

    <li>
      <a
        href="/services/railings"
        onClick={(e) => handleNavigation(e, '/services/railings')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Custom Railings
      </a>
    </li>

    <li>
      <a
        href="/services/landscaping"
        onClick={(e) => handleNavigation(e, '/services/landscaping')}
        className="text-gray-400 hover:text-beaver-green transition-colors"
      >
        Landscaping Services
      </a>
    </li>

  </ul>
</div>

            <div>
              <h3 className="text-lg font-bold text-white mb-4 font-secondary uppercase">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="/about-us" onClick={(e) => handleNavigation(e, '/about-us')} className="text-gray-400 hover:text-beaver-green transition-colors">About Our Team</a></li>
                <li><a href="/testimonials" onClick={(e) => handleNavigation(e, '/testimonials')} className="text-gray-400 hover:text-beaver-green transition-colors">Client Reviews</a></li>
                <li><a href="/blog" onClick={(e) => handleNavigation(e, '/blog')} className="text-gray-400 hover:text-beaver-green transition-colors">Expert Blog & Tips</a></li>
                <li><a href="/estimate" onClick={(e) => handleNavigation(e, '/estimate')} className="text-gray-400 hover:text-beaver-green transition-colors">Online Deck Cost Calculator</a></li>
                <li><a href="/fence-estimate" onClick={(e) => handleNavigation(e, '/fence-estimate')} className="text-gray-400 hover:text-beaver-green transition-colors">Online Fence Cost Calculator</a></li>
                <li><a href="/appointment" onClick={(e) => handleNavigation(e, '/appointment')} className="text-gray-400 hover:text-beaver-green transition-colors">Book Free Consultation</a></li>
                <li><a href="/contact" onClick={(e) => handleNavigation(e, '/contact')} className="text-gray-400 hover:text-beaver-green transition-colors">Contact Us</a></li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-bold text-white font-secondary uppercase">Contact Us</h3>
              <address className="not-italic text-sm text-gray-400 space-y-1">
                <span className="block font-bold text-white">Busy Beaver Construction Ltd.</span>
                <span className="block italic">Calgary’s Premier Deck & Fence Builder</span>
                <span className="block">62 Silverado Ranch Way SW</span>
                <span className="block">Calgary, AB T2X 0C6, Canada</span>
              </address>
              <div className="pt-2">
                <p className="text-sm font-bold">
                  <a 
                    href="tel:4032865400" 
                    className="text-beaver-red hover:text-white transition-colors"
                    onClick={() => {
                      (window as any).dataLayer = (window as any).dataLayer || [];
                      (window as any).dataLayer.push({ event: 'phone_click' });
                    }}
                  >
                    403-286-5400
                  </a>
                </p>
                <p className="text-sm">
                  <a href="mailto:sales@busybeaverconstruction.com" className="text-gray-400 hover:text-white transition-colors">sales@busybeaverconstruction.com</a>
                </p>
              </div>
              <div className="pt-4">
                <a 
                  href="/appointment" 
                  className="bg-beaver-green text-black px-6 py-3 font-bold uppercase text-xs rounded hover:brightness-110 transition-all duration-300 inline-block font-accent"
                  onClick={(e) => handleNavigation(e, '/appointment')}
                >
                  BOOK FREE ESTIMATE
                </a>
              </div>
            </div>

          </div>

          <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 gap-4">
            <p>© {new Date().getFullYear()} Busy Beaver Construction Ltd. All Rights Reserved.</p>
            <div className="flex space-x-6">
              <a href="/sitemap.xml" target="_blank" className="hover:text-white">XML Sitemap</a>
              <span className="hidden md:inline">|</span>
              <span>Serving Calgary, Okotoks, Airdrie & Surrounding Areas</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}